import {OrderStatus} from '@domain/model/Order/OrderStatus';
import {CheckoutProjection} from '@lookiero/checkout/dist/src/projection/checkout/checkout';

interface GetActiveStepFunction {
  ({
    checkout,
    orderStatus,
  }: {
    checkout: CheckoutProjection | undefined;
    orderStatus: keyof typeof OrderStatus | undefined;
  }): number;
}

const getActiveStep: GetActiveStepFunction = ({checkout, orderStatus}): number => {
  if (checkout) {
    return 4;
  }

  if (orderStatus === OrderStatus.BORRADOR || orderStatus === OrderStatus.PEDIDO_REALIZADO) {
    return 0;
  }
  if (orderStatus === OrderStatus.EN_MARCHA) {
    return 1;
  }
  if (orderStatus === OrderStatus.EN_PREPARACION) {
    return 2;
  }
  if (orderStatus === OrderStatus.ENVIADO) {
    return 3;
  }

  return -1;
};

export {getActiveStep};
